import { createAction } from '@reduxjs/toolkit';

const setCountries = createAction('countries/list/set');

export { setCountries };
